import { apiClient } from './axios';

// ── Request/Response Types ──────────────────────────────────────────────────

export interface MintNFTCardanoRequest {
  petId: string;
  imageKey: string;
  artworkType: string;
  frame?: string;
  background?: string;
  caption?: string;
  seasonTheme?: string;
}

export interface MintNFTCardanoResponse {
  id: string;
  cardanoTxHash: string;
  cardanoAssetId: string;
  name: string;
  network: string;
  explorerUrl: string;
  message: string;
}

export interface NFTCardanoItem {
  id: string;
  petId: string;
  cardanoTxHash: string | null;
  cardanoAssetId: string | null;
  cardanoPolicyId: string | null;
  name: string;
  imageUrl: string | null;
  artworkType: string;
  frame: string | null;
  background: string | null;
  caption: string | null;
  seasonTheme: string | null;
  network: string;
  hidden: boolean;
  createdAt: string;
  explorerUrl: string | null;
}

export interface ListNFTsCardanoResponse {
  nfts: NFTCardanoItem[];
  total: number;
}

// ── API Functions ───────────────────────────────────────────────────────────

/**
 * Mint an NFT on Cardano. Backend handles the full transaction (CIP-68
 * reference NFT + user NFT + $PET payment in one tx).
 * Prerequisites: user must have a Cardano wallet and sufficient $PET balance.
 */
export async function mintNFTCardano(
  request: MintNFTCardanoRequest,
): Promise<MintNFTCardanoResponse> {
  const response = await apiClient.post<MintNFTCardanoResponse>(
    '/nft-cardano/mint',
    request,
  );
  return response.data;
}

/**
 * List the authenticated user's Cardano-minted NFTs. Optionally filter by pet.
 */
export async function listNFTsCardano(petId?: string): Promise<ListNFTsCardanoResponse> {
  const params = petId ? { petId } : {};
  const response = await apiClient.get<ListNFTsCardanoResponse>('/nft-cardano/list', {
    params,
  });
  return response.data;
}
